import React from "react";
import SidebarProfile from "../common/sidebarProfile";
import leftarrow from "../../assets/Image/leftarrow.svg";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebarmob from "../common/sidebarMobile";
import PostRequest from "../apiConnection/postRequest";
import { getLocalStoarge, decryptFunction } from "../common/allfunction";


function privacy() {
  const [isLoading, setIsLoading] = useState(false);
  const [userLang, setUserLang] = useState(getLocalStoarge("langauage"));
  const [alerts, setAlerts] = useState({
    alert: "",
    alerttype: "",
    alertclass: "danger",
    showalert: false,
  });
  const [privacypolicy, setPrivacyPolicy] = useState("");
  const [heading, setHeading] = useState("");
  const [consentIdEN, setConsentIdEN] = useState(decryptFunction(localStorage.getItem('consentIdEnglish')));
  const [consentIdIT, setConsentIdIT] = useState(decryptFunction(localStorage.getItem('consentIdItalian')));

  // const encryptedDataEN = localStorage.getItem('consentIdEnglish');
  // const decryptedDataEN = decryptFunction(localStorage.getItem('consentIdEnglish'));
  // setConsentIdEN(decryptedDataEN);

  // const encryptedDataIT = localStorage.getItem('consentIdEnglish');
  // const decryptedDataIT = decryptFunction(encryptedDataIT);
  // setConsentIdIT(decryptedDataIT);


  const getConsentsDetails = async (e) => {
    setIsLoading(true);
    try {
      const payload = {
        consent_id: (userLang == "en")? consentIdEN : consentIdIT,
      }
      const getConsents = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_CONSENT}`,
        payload
      );
      if (getConsents && getConsents.status === 200) {
        if (getConsents.data.code === 200) {
          setIsLoading(false);
          setPrivacyPolicy(getConsents.data.data.privacy_policy.full_text);
          setHeading(getConsents.data.data.privacy_policy.title)
        } else {
          setIsLoading(false);
          setAlerts({
            alert: "",
            alerttype: "Error",
            alertclass: "danger",
            showalert: true,
          });
        }

      } else {
        setIsLoading(false);
        setAlerts({
          alert: "Internal server error.",
          alerttype: "Error",
          alertclass: "danger",
          showalert: true,
        });
      }
    } catch (error) {
      setIsLoading(false);
      setAlerts({
        alert: "Internal server error.",
        alerttype: "Error",
        alertclass: "danger",
        showalert: true,
      });
    }
  };
  useEffect(() => {
   
    getConsentsDetails();
  }, []);
  return (
    <>
    <section className="bg-privacy dashboard-mobile">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2 topspace d-lfti none-viewport ipad-widhset">
            <SidebarProfile />
          </div>
          <div className="col-md-10  ipd-righ">
            <div className="top-priv-static">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="otp-heading m-bspaci imposta referment-h">
                    <Link to="/profilemenu">
                      <img src={leftarrow} className="deskt-n" alt="icon" /></Link>
                    {heading}
                  </h2>
                </div>

                <div className="col-md-12">
                 <div className="static-left res-pon">
                  <p
                    dangerouslySetInnerHTML={{__html: privacypolicy}}
                      />
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </section>
   < div className="act-ve">
   <Sidebarmob/>
  </div>
</>
  );
}

export default privacy;
